<template>
  <div class="custom-form cmi-donate-form cmi-card-view">
    <div class="panel panel-primary">
      <div class="panel-heading">
        <h2 class="panel-title">Donation Details</h2>
      </div>
      <div class="panel-body">
        <div
          class="form-group"
          v-bind:class="{ 'has-error': errors.has('dnt_DonationCause') }"
        >
          <label for="dnt_DonationCause"
            >I would like my donation to go to</label
          >
          <select
            id="dnt_DonationCause"
            name="dnt_DonationCause"
            v-model.trim="fdata.dnt_DonationCause"
            v-validate.initial="{ required: true }"
            class="form-control"
          >
            <option></option>
            <option
              v-for="item in donationCauses"
              v-bind:value="item.value"
              :key="item.value"
              >{{ item.label }}</option
            >
            <option value="-1">Other</option>
          </select>
          <span
            v-if="aniDonationCausesLoading"
            class="fa fa-spinner fa-spin fa-3x fa-fw"
          ></span>
          <span class="help-block">{{
            errors.first("dnt_DonationCause")
          }}</span>
        </div>

        <div
          class="form-group"
          v-bind:class="{ 'has-error': errors.has('dnt_DonationCauseText') }"
        >
          <label for="dnt_DonationCauseText"
            >Please specify which causes you would like your donation to go
            to</label
          >
          <input
            id="dnt_DonationCauseText"
            name="dnt_DonationCauseText"
            v-model.trim="fdata.dnt_DonationCauseText"
            v-validate.initial="{
              required: !disableCriteriaMet_dnt_DonationCauseText,
              max: 100,
            }"
            v-bind:disabled="disableCriteriaMet_dnt_DonationCauseText"
            maxlength="100"
            class="form-control"
          />
          <span class="help-block">{{
            errors.first("dnt_DonationCauseText")
          }}</span>
        </div>

        <div
          class="form-group"
          v-bind:class="{ 'has-error': errors.has('dnt_DonationComments') }"
        >
          <label for="dnt_DonationComments">Additional comments</label>
          <textarea
            id="dnt_DonationComments"
            name="dnt_DonationComments"
            v-model.trim="fdata.dnt_DonationComments"
            v-validate="{ max: 2000 }"
            maxlength="2000"
            rows="4"
            class="form-control"
          ></textarea>
          <span class="help-block">{{
            errors.first("dnt_DonationComments")
          }}</span>
        </div>

        <div
          class="form-group"
          v-bind:class="{ 'has-error': errors.has('dnt_Amount') }"
        >
          <label for="dnt_Amount">Amount ($)</label>
          <select
            id="dnt_Amount"
            name="dnt_Amount"
            v-model="fdata.dnt_Amount"
            v-validate.initial="{ required: true }"
            class="form-control"
          >
            <option></option>
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="150">150</option>
            <option value="200">200</option>
            <option value="300">300</option>
            <option value="400">400</option>
            <option value="500">500</option>
            <option value="97">Other</option>
          </select>
          <span class="help-block">{{ errors.first("dnt_Amount") }}</span>
        </div>

        <div
          class="form-group"
          v-bind:class="{ 'has-error': errors.has('dnt_AmountOther') }"
        >
          <label for="dnt_AmountOther">Specify amount ($)</label>
          <input
            id="dnt_AmountOther"
            name="dnt_AmountOther"
            v-model.trim="fdata.dnt_AmountOther"
            v-validate.initial="{
              required: !disableCriteriaMet_dnt_AmountOther,
              decimal: 2,
              max: 7,
            }"
            v-bind:disabled="disableCriteriaMet_dnt_AmountOther"
            maxlength="7"
            class="form-control"
          />
          <span class="help-block">{{ errors.first("dnt_AmountOther") }}</span>
        </div>

        <div
          class="form-group"
          v-bind:class="{ 'has-error': errors.has('dnt_NameOnCard') }"
        >
          <label for="dnt_NameOnCard">Name on card</label>
          <input
            id="dnt_NameOnCard"
            name="dnt_NameOnCard"
            v-model.trim="fdata.dnt_NameOnCard"
            v-validate.initial="{ required: true, max: 100 }"
            maxlength="100"
            class="form-control"
          />
          <span class="help-block">{{ errors.first("dnt_NameOnCard") }}</span>
        </div>

        <div
          class="form-group"
          v-bind:class="{ 'has-error': errors.has('dnt_Email') }"
        >
          <label for="dnt_Email">Email</label>
          <input
            id="dnt_Email"
            name="dnt_Email"
            v-model.trim="fdata.dnt_Email"
            v-validate.initial="{ required: true, max: 100, email: true }"
            maxlength="100"
            class="form-control"
          />
          <span class="help-block">{{ errors.first("dnt_Email") }}</span>
        </div>

        <div class="form-group" v-bind:class="{ 'has-error': cardError }">
          <label for="cad_card">Card</label>
          <div id="cad_card" class="form-control">
            card here
          </div>
          <span class="help-block">{{ cardError }}</span>
        </div>
        <div class="btn-submit-wrapper">
          <div v-if="showAnimation" class="cc-animation">
            <span class="fa fa-spinner fa-spin fa-3x fa-fw"></span><br />
            <span>Payment in progress</span>
          </div>
          <div class="cmi-payment-btn-wrapper">
            <button
              @click="initialisePayment"
              v-bind:disabled="showAnimation"
              type="submit"
              class="btn btn-lg btn-block btn-primary"
            >
              Pay <span class="cmi-card-amount">$ {{ amount }}</span>
            </button>
          </div>
        </div>
        <div class="stipe-badge-wrapper">
          <img
            class="stipe-badge"
            src="/dist/assets/stripe/powered_by_stripe.png"
          />
        </div>
        <div class="cmi-card-icons">
          <div class="row">
            <div class="col-sm-4 col-xs-6">
              <img
                class="img-responsive"
                alt="We accept Visa"
                title="We accept Visa"
                src="/dist/assets/CardLogos/1.png"
              />
            </div>
            <div class="col-sm-4 col-xs-6">
              <img
                class="img-responsive"
                alt="We accept MasterCard"
                title="We accept MasterCard"
                src="/dist/assets/CardLogos/2.png"
              />
            </div>
            <div class="col-sm-4 col-xs-6">
              <img
                class="img-responsive"
                alt="We accept American Express"
                title="We accept American Express"
                src="/dist/assets/CardLogos/22.png"
              />
            </div>
            <div class="col-sm-4 col-xs-6">
              <img
                class="img-responsive"
                alt="We accept JCB"
                title="We accept JCB"
                src="/dist/assets/CardLogos/16.png"
              />
            </div>
            <div class="col-sm-4 col-xs-6">
              <img
                class="img-responsive"
                alt="We accept Discover"
                title="We accept Discover"
                src="/dist/assets/CardLogos/14.png"
              />
            </div>
            <div class="col-sm-4 col-xs-6">
              <img
                class="img-responsive"
                alt="We accept Diners Club International"
                title="We accept Diners Club International"
                src="/dist/assets/CardLogos/10.png"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <modal
        name="alert-dialog-donate"
        @before-open="beforeOpenDialog"
        @before-close="beforeCloseDialog"
        :width="380"
        :height="'auto'"
        :clickToClose="false"
      >
        <div class="panel-primary">
          <div class="panel-heading modal-alert-heading">
            <span class="modal-alert-title">Information</span>
            <button
              @click="closeAlertDialog"
              type="button"
              class="close pull-right"
            >
              <span
                class="fa fa-times-circle modal-alert-close-button-icon"
              ></span>
            </button>
          </div>
          <div class="panel-body modal-alert-body">
            <div class="modal-alert-text-wrapper">
              <span class="fa fa-exclamation-circle modal-alert-icon"></span>
              <span class="modal-alert-text">
                {{ alertMessage }}
              </span>
            </div>
            <div class="modal-alert-footer">
              <button
                @click="closeAlertDialog"
                type="button"
                class="btn btn-primary"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { loadStripe } from "@stripe/stripe-js";
const stripeKey =
  "pk_test_51HMHeuDw4NqbT9Hu55wCGNKpc7J2CMBd5eNEt7FFNpQ4aKdsp5rOXSgqFuJdtQ6Gg40HlEZ3c6NYkKvMlrrziw8C00gqLfa4U3";
export default {
  props: {
    baseUrl: { type: String },
  },
  data() {
    return {
      fdata: {
        dnt_DonationCause: null,
        dnt_DonationCauseText: "",
        dnt_DonationComments: "",
        dnt_Amount: null,
        dnt_AmountOther: null,
        dnt_NameOnCard: "",
        dnt_Email: "",
      },
      sData: {
        amount: null,
        id: "",
        clientSecret: "",
      },
      donationCauses: [],
      aniDonationCausesLoading: false,
      showAnimation: false,
      alertMessage: "",
      alertParams: null,
      cardElement: null,
      cardError: "",
      stripe: null,
    };
  },
  methods: {
    getDonationCauses: async function() {
      this.aniDonationCausesLoading = true;

      let rData = null;
      let actionUrl = `${this.baseUrl}GetDonationCauses`;
      try {
        ({ data: rData } = await axios.get(actionUrl));
      } catch (error) {
        this.aniDonationCausesLoading = false;
        throw error;
      }
      if (rData) {
        this.donationCauses = rData;
      }
      this.aniDonationCausesLoading = false;
    },
    initialisePayment: async function() {
      const valStatus = await this.$validator.validateAll();
      if (!valStatus || this.cardError) {
        this.alertMessage = "Form contains validation warnings";
        this.$modal.show("alert-dialog-donate");
        return;
      }
      let rData = null;
      let actionUrl = `${this.baseUrl}InitialisePayment`;
      this.sData.amount = this.amount;
      this.showAnimation = true;
      try {
        ({ data: rData } = await axios.post(actionUrl, this.sData));
      } catch (error) {
        this.showAnimation = false;
        throw error;
      }
      if (rData.status == 0) {
        const d = rData.data;
        this.sData.id = d.id;
        this.sData.clientSecret = d.clientSecret;
        this.processPayment();
      } else {
        this.alertMessage =
          "Sorry we have encountered unexpected technical issues, please try again later";
        this.$modal.show("alert-dialog-donate");
      }
      this.showAnimation = false;
    },
    processPayment: async function() {
      if (!this.sData.clientSecret) {
        return;
      }
      const pResult = await this.stripe.confirmCardPayment(
        this.sData.clientSecret,
        {
          payment_method: {
            card: this.cardElement,
            billing_details: {
              name: this.fdata.dnt_NameOnCard,
              email: this.fdata.dnt_Email,
            },
          },
        }
      );
      if (pResult.error) {
        if (this.cardError) {
          this.alertMessage = "Form contains validation warnings";
        } else {
          this.alertMessage =
            "Payment failed, please check that your card details are correct and try again";
        }
        this.$modal.show("alert-dialog-donate");
      } else {
        await this.submitDonationData();
      }
    },
    submitDonationData: async function() {
      let rData = null;
      let actionUrl = `${this.baseUrl}SaveDonationData`;
      try {
        ({ data: rData } = await axios.post(actionUrl, this.fdata));
      } catch (error) {
        this.showAnimation = false;
        throw error;
      }
      if (rData == 0) {
        this.resetFormData();
        Object.assign(this.sData, {
          amount: null,
          id: "",
          clientSecret: "",
        });
        this.cardElement.clear();
        this.alertMessage = "Thank you for giving";
        this.$modal.show("alert-dialog-donate", { status: 2 });
      }
    },
    initialiseCardElements: async function() {
      this.stripe = await loadStripe(stripeKey);
      const elements = this.stripe.elements();
      this.cardElement = elements.create("card", {
        hidePostalCode: false,
        style: {
          base: {
            fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
            fontSize: "18px",
          },
        },
      });
      this.cardElement.addEventListener("change", ({ error }) => {
        if (error) {
          this.cardError = error.message;
        } else {
          this.cardError = "";
        }
      });
      this.cardElement.mount("#cad_card");
    },
    resetFormData: function() {
      Object.assign(this.fdata, {
        dnt_DonationCause: null,
        dnt_DonationCauseText: "",
        dnt_DonationComments: "",
        dnt_Amount: null,
        dnt_AmountOther: null,
        dnt_NameOnCard: "",
        dnt_Email: "",
      });
    },
    closeAlertDialog: function() {
      this.$modal.hide("alert-dialog-donate");
    },
    beforeOpenDialog: function({ params }) {
      if (params) {
        this.alertParams = params.status;
      }
    },
    beforeCloseDialog: function() {
      if (this.alertParams == 2) {
        this.alertParams = null;
        window.location.href = "/shop-products";
      }
    },
  },
  watch: {
    disableCriteriaMet_dnt_DonationCauseText: function(newValue) {
      if (newValue == false) {
        this.fdata.dnt_DonationCauseText = "";
      }
    },
    disableCriteriaMet_dnt_AmountOther: function(newValue) {
      if (newValue == false) {
        this.fdata.dnt_AmountOther = null;
      }
    },
  },
  computed: {
    amount: function() {
      return this.fdata.dnt_Amount == 97
        ? this.fdata.dnt_AmountOther
        : this.fdata.dnt_Amount;
    },
    disableCriteriaMet_dnt_DonationCauseText: function() {
      if (
        this.fdata.dnt_DonationCause != null &&
        [-1].indexOf(this.fdata.dnt_DonationCause) != -1
      ) {
        return false;
      }
      return true;
    },
    disableCriteriaMet_dnt_AmountOther: function() {
      if (
        this.fdata.dnt_Amount != null &&
        [97].indexOf(this.fdata.dnt_Amount) != -1
      ) {
        return false;
      }
      return true;
    },
  },
  async mounted() {
    this.initialiseCardElements();
    await this.getDonationCauses();
  },
};
</script>
